import React from 'react';

import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from 'styled-components';

import { MenuItemHeader } from 'components/Layout/Header/components/MegaMenuItem/megamenu-item.styles';

import MenuItemSubHeader from 'components/Layout/Header/components/MegaMenuItem/components/MegaMenuItemBody/components/MenuItemSubHeader';
import Link from 'components/Link';

import { MenuColumnSubMenuItemI } from 'interfaces/content-stack/contentStack.types';

import { getModularBlockLink, getModularBlockLinkData } from 'utils/modularBlockUtils';

const LinkListWrapper = styled.div`
  padding: 1rem;
`;

const ContentLink = styled(Link)`
  text-decoration: none;
  cursor: pointer;
  color: ${(props) => props.theme.colors.black};
`;

const TertiaryLink = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
  color: ${(props) => props.theme.colors.black};
  font-weight: 600;
  font-family: ${(props) => props.theme.fonts.default};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 0.875rem;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }

  &:hover {
    color: ${(props) => props.theme.colors.primaryRed};
  }
`;

const LinkList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.75rem;
`;

interface MegaMenuBodyLinkListProps {
  linkList: MenuColumnSubMenuItemI;
}

const MegaMenuItemBodyLinkList = ({ linkList }: MegaMenuBodyLinkListProps) => {
  const { linkText, link, snippet, tertiaryMenuItems } = linkList;
  const url = getModularBlockLink(link);

  return (
    <LinkListWrapper>
      <ContentLink to={url} data-testid='desktop-navbar-item'>
        <MenuItemHeader>
          {linkText}
          &nbsp;
          <FontAwesomeIcon icon={faChevronRight} size='xs' />
        </MenuItemHeader>
        <MenuItemSubHeader richText={snippet} />
      </ContentLink>
      {tertiaryMenuItems && (
        <LinkList>
          {tertiaryMenuItems.map((tertiaryItem, index) => {
            const { link, target } = getModularBlockLinkData(tertiaryItem.link);
            return (
              <TertiaryLink
                to={link}
                key={index}
                target={target}
                data-testid='desktop-navbar-item'
              >
                {tertiaryItem.linkText}
              </TertiaryLink>
            );
          })}
        </LinkList>
      )}
    </LinkListWrapper>
  );
};

export default MegaMenuItemBodyLinkList;
